module.exports = __webpack_public_path__ + "img/imgpsh_mobile_save.b7603510.jpg";